import { Navigate, useParams, useSearchParams } from 'react-router-dom';

export function ModelInvitationPage() {
  const { code } = useParams<{ code: string }>();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const suffix = token ? `?token=${encodeURIComponent(token)}` : '';

  return <Navigate to={code ? `/s/${code}${suffix}` : '/'} replace />;
}
